import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { url: String, frame: String }

  save() {
    // Perform the frame-specific visit
    Turbo.visit(this.urlValue, { frame: this.frameValue })
  }

  checkEscape(event) {
    if (event.key === "Escape") {
      this.element.blur()
    }
  }
}
